/*
 * Browser detection functionality
 */


// Import modules
import { ErrorHandler } from 'errorhandler/errorhandler.js';
import * as bowser from 'bowser/bowser.min.js';


/**
 * Main class for BrowserDetection.
 *
 * @class      BrowserDetection
 */
export class BrowserDetection
{
	/**
	 * Generates slugs decent enough for our data attributes from names.
	 *
	 * @param      {string}  name    The string to convert to slug
	 * @return     {string}  Slug representation of string
	 */
	static convertToSlug( name = '' )
	{
		// Is it string?
		if ( typeof name !== 'string' )
		{
			// Can we convert it to a string?
			if ( typeof name.toString === 'function' )
			{
				// Convert it
				name = name.toString();
			}
			// Nope
			else
			{
				// Let's just return an empty string then
				return '';
			}
		}

		// Turn a few selected character into dashes, lowercase it, and remove whatever special characters are left
		name = name
			.replace( /[\s\._]/g, '-' )
			.toLowerCase( name )
			.replace( /[^a-z0-9-]/g, '' );

		// Return it
		return name;
	};





	/**
	 * Class constructor.
	 */
	constructor()
	{
		// Reference self
		let _this = this;


		// Member variables
		_this.browserInfo =
		{
			'name':    '',
			'slug':    '',
			'version': '',
		};
		_this.OSInfo =
		{
			'name':    '',
			'slug':    '',
			'version': '',
		};
	}





	/**
	 * Try to detect what we can about the browser.
	 */
	detect()
	{
		try
		{
			// Reference self
			let _this = this;

			// Element references
			let $body = $( 'body' );

			// Make sure Bowser is properly loaded
			if ( typeof bowser !== 'undefined' )
			{
				// Do we have browser name?
				if ( typeof bowser.name !== 'undefined' )
				{
					// Set browser name
					_this.browserInfo.name = bowser.name;

					// Set browser slug
					_this.browserInfo.slug = BrowserDetection.convertToSlug( bowser.name );
				}

				// Do we have browser version?
				if ( typeof bowser.version !== 'undefined' )
				{
					// Set browser version
					_this.browserInfo.version = bowser.version;
				}

				// Do we have OS name?
				if ( typeof bowser.osname !== 'undefined' )
				{
					// Set OS name
					_this.OSInfo.name = bowser.osname;

					// Set OS slug
					_this.OSInfo.slug = BrowserDetection.convertToSlug( bowser.osname );
				}

				// Do we have OS version?
				if ( typeof bowser.osversion !== 'undefined' )
				{
					// Set OS version
					_this.OSInfo.version = bowser.osversion;
				}


				// Att everything about the browser to data attributes
				for ( let attribute in _this.browserInfo )
				{
					// Only print it if it's either a string or number
					if ( typeof _this.browserInfo[ attribute ] === 'string' || typeof _this.browserInfo[ attribute ] === 'number' )
					{
						$body.attr( 'data-browser-' + attribute, _this.browserInfo[ attribute ] );
					}
				}

				// Att everything about the OS to data attributes
				for ( let attribute in _this.OSInfo )
				{
					// Only print it if it's either a string or number
					if ( typeof _this.OSInfo[ attribute ] === 'string' || typeof _this.OSInfo[ attribute ] === 'number' )
					{
						$body.attr( 'data-os-' + attribute, _this.OSInfo[ attribute ] );
					}
				}
			}
		}
		catch( err )
		{
			ErrorHandler.error( 'BrowserDetection', 'detect', err );
		}
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/browserdetection/browserdetection.js